import React from "react";
import { AlertTriangle, RefreshCw, Wifi, WifiOff } from "lucide-react";
import { Button } from "../../../../shadcn/ui/button";

const GlobalErrorState = ({ onRetry, className = "" }) => {
  return (
    <div className={`py-16 text-center ${className}`}>
      <div className="max-w-md mx-auto">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <WifiOff className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Unable to load data</h2>
          <p className="text-gray-600 mb-6">
            We're having trouble loading your client management data. This could be due to a network issue or server
            problem.
          </p>
        </div>

        <div className="space-y-3">
          <Button onClick={onRetry} className="w-full bg-blue-600 hover:bg-blue-700 text-white">
            <RefreshCw className="w-4 h-4 mr-2" />
            Retry loading data
          </Button>

          <div className="text-sm text-gray-500">
            <p>If the problem persists, please:</p>
            <ul className="mt-2 space-y-1">
              <li>• Check your internet connection</li>
              <li>• Try refreshing the page</li>
              <li>• Contact support if needed</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalErrorState;
